import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { RolesSharedService } from '../../services/roles-shared.service';
import { MarketDataChartGeneratorService } from '../../services/market-data-chart-generator.service';
import { AuthenticationService } from '@app/shared/services/authentication.service';

@Component({
  selector: 'app-individual-marketdata',
  templateUrl: './individual-marketdata.component.html',
  styleUrls: ['./individual-marketdata.component.css']
})
export class IndividualMarketdataComponent implements OnInit {
researchDocList: any;
marketDat: any = {
  ChartJSON: {
  }
};  
userRole;

constructor(public rolesSharedService: RolesSharedService,
  private marketDataChartGeneratorService: MarketDataChartGeneratorService,
  private authenticationService: AuthenticationService,
  private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params: Params) => {
      this.getIndividualMarketData(params);
      this.getResearchDocList(params);
    });
    this.getRole();
  }
  goBack() {
    this.router.navigate([`/global-search`]);
  }
  getResearchDocList(params) {
    let filter = {
      where: {
        marketDataId: params.marketDataId
      }
    };
    this.rolesSharedService.getResearchDocumentList(filter).subscribe((response) => {
      this.researchDocList = response;
    });
  }
  getIndividualMarketData(params) {
    let marketDataId = params.marketDataId;
    this.rolesSharedService.getIndividualMarketDataResults(marketDataId).subscribe((response) => {
      this.marketDat = response;
      this.marketDataChartGeneratorService.generateChartJSON(this.marketDat).subscribe((chartJSON: any) => {
        this.marketDat.ChartJSON = chartJSON;
      });
    });
  }
  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }
  navigateToResearchDoc(researchDoc) {
    if (this.userRole === 'tech-vendor') {
      this.router.navigate([`${this.userRole}/market-data/${researchDoc.researchDocumentId}`]);
    } else {
      this.router.navigate([`${this.userRole}/research-snapshot/${researchDoc.researchDocumentId}`]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/individual-marketdata/individual-marketdata.component.ts